import React from "react";

import { IconButton, Tooltip } from "@material-ui/core";
import InfoOutlined from "@material-ui/icons/InfoOutlined";

export default function InfoField(props) {
  return (
    <Tooltip
      style={{ margin: "0px", padding: "0px 3px" }}
      title={props.description}
      color="primary"
    >
      <IconButton aria-label="info">
        <InfoOutlined style={{ width: "16px", marginBottom: "1px" }} />
      </IconButton>
    </Tooltip>
  );
}
